import React from 'react';

//components
import Container from 'components/Container';
import {Link} from 'components/Link';

export default function AccountBreadcrumb({
  currentPageLabel,
  homePageLabel,
}: {
  currentPageLabel: string;
  homePageLabel: string;
}) {
  return (
    <Container>
      <nav className="mt-6 mb-[65px] flex flex-wrap items-center">
        <Link
          to="/"
          className="transition-colors duration-200 ease-out hover:text-hk-orange"
        >
          {homePageLabel}
        </Link>
        <span className="mx-2 inline-block">/</span>
        <span className="text-hk-orange">{currentPageLabel}</span>
      </nav>
    </Container>
  );
}
